import React, {useState, useEffect} from "react";
import { getStore } from "../../../utils/functions"
import { Button } from "../../../components/ui/panel-button"
import { Text } from "../../../components/ui/text"
import { Heading } from "../../../components/ui/heading"
import { Img } from "../../../components/ui/img"
import { SelectBox} from "../../../components/ui/selectbox";
import CircularProgressBar from "../../../components/ui/circular-progressbar";
import LineChart from "../../../components/ui/line-chart";
import "react-circular-progressbar/dist/styles.css";

const chartOptions = [
  { label: "This year", value: "This year" },
  { label: "This month", value: "This month" },
  { label: "Today", value: "Today" },
];


export default function DashboardPage() {
  const auth = getStore("auth")

  const [totalBins, setTotalBins] = useState(0);
  const [filledBins, setFilledBins] = useState(0);
  const [unfilledBins, setUnfilledBins] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [userData, setUserData] = useState([]);
  const [timePeriod, setTimePeriod] = useState('This year');

  const options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: timePeriod === 'This year' ? 'month' : 
              timePeriod === 'This month' ? 'day' : 'hour',
          displayFormats: {
            month: 'MMMM yyyy',
            day: 'MMMM dd',
            hour: 'HH:mm'
          },
          parser: (value) => {
            if (timePeriod === 'Today') {
              const today = new Date();
              const date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), value);
          
              return date;
              
            } else {
              // For 'This year' and 'This month', parse the value as a date-time string
              return new Date(value);
            }
          },
        },
      },
      y: {
        type: 'linear',
        ticks: {
          min: 0,
          stepSize: 1,
          callback: function(value) {
            if (Math.floor(value) === value) {
              return value;
            }
          },
        }
      },
    },
  };

  useEffect(() => {
    fetch('/api/dashboard-data', {
        headers: { Authorization: `Token ${auth.token}` }
    })
      .then(response => response.json())
      .then(data => {
        setTotalBins(data.totalBins);
        setFilledBins(data.filledBins);
        setUnfilledBins(data.unfilledBins);
        setTotalUsers(data.totalUsers);
      });
  }, []);

  useEffect(() => {
    fetch(`/api/users-data?timePeriod=${timePeriod}`, {
      headers: { Authorization: `Token ${auth.token}` }
    })
      .then(response => response.json())
      .then(data => setUserData(data));
  }, [timePeriod]);

  return (
    <>
      <div className="w-full pb-8 sm:pb-5 bg-gray-100_01">
        <div>
          <div className="flex flex-col gap-6">
            <div className="flex flex-col w-full gap-6 mx-auto md:p-5 max-w-[1376px]">
              <div className="flex md:flex-col gap-6">
                <div className="flex justify-center w-full p-[18px] bg-white-A700 rounded-[10px]">
                  <div className="flex justify-between items-center w-full gap-5">
                    <div className="flex flex-col self-start items-start gap-[18px]">
                      <Heading as="h1" className="h-[39px] tracking-[-1.60px]">
                        { totalBins }
                      </Heading>
                      <Text size="s" as="p" className="!text-black-900_87 opacity-0.5">
                        Total Bins
                      </Text>
                    </div>
                    <div className="flex flex-col items-end w-[17%] gap-[30px]">
                      <Img
                        src="/media/images/panel/img_frame_427320451_gray_100.svg"
                        alt="circleimage"
                        className="h-[28px] w-[28px] rounded-[50%]"
                      />
                      <Text
                        size="xs"
                        as="p"
                        className="flex justify-center items-center h-[24px] px-2 py-[3px] !text-green-900 tracking-[0.72px] !font-jost border-light_green-200 border border-solid bg-light_green-100 rounded"
                      >
                        +20%
                      </Text>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-full p-[18px] bg-white-A700 rounded-[10px]">
                  <div className="flex justify-between items-center w-full gap-5">
                    <div className="flex flex-col self-start items-start gap-[18px]">
                      <Heading as="h2" className="tracking-[-1.60px]">
                        { filledBins }
                      </Heading>
                      <Text size="s" as="p" className="!text-black-900_87 opacity-0.5">
                        Filled Bins
                      </Text>
                    </div>
                    <div className="flex flex-col items-end gap-[30px]">
                      <Button className="flex items-center justify-center h-[28px] w-[28px] bg-gray-100 rounded-[50%]">
                        <Img src="/media/images/panel/img_frame_427320451.svg" />
                      </Button>
                      <Text
                        size="xs"
                        as="p"
                        className="flex justify-center items-center h-[24px] px-2 py-[3px] !text-green-900 tracking-[0.72px] !font-jost border-light_green-200 border border-solid bg-light_green-100 rounded"
                      >
                        +3%
                      </Text>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-full p-[18px] bg-white-A700 rounded-[10px]">
                  <div className="flex justify-between items-center w-full gap-5">
                    <div className="flex flex-col self-start items-start gap-[18px]">
                      <Heading as="h3" className="h-[39px] tracking-[-1.60px]">
                        { unfilledBins }
                      </Heading>
                      <Text size="s" as="p" className="!text-black-900_87 opacity-0.5">
                        UnFilled Bins
                      </Text>
                    </div>
                    <div className="flex flex-col items-end gap-[30px]">
                      <Button className="flex items-center justify-center h-[28px] w-[28px] bg-gray-100 rounded-[50%]">
                        <Img src="/media/images/panel/img_frame_427320451_blue_gray_700.svg" />
                      </Button>
                      <Text
                        size="xs"
                        as="p"
                        className="flex justify-center items-center h-[24px] px-2 py-[3px] !text-red-900 tracking-[0.72px] !font-jost border-red-100_01 border border-solid bg-deep_orange-50_01 rounded"
                      >
                        -2%
                      </Text>
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-full p-[18px] bg-white-A700 rounded-[10px]">
                  <div className="flex justify-between items-center w-full gap-5">
                    <div className="flex flex-col self-start items-start gap-[18px]">
                      <Heading as="h4" className="h-[39px] tracking-[-1.60px]">
                        { totalUsers }
                      </Heading>
                      <Text size="s" as="p" className="!text-black-900_87 opacity-0.5">
                        Total Users
                      </Text>
                    </div>
                    <div className="flex flex-col items-end w-[17%] gap-[30px]">
                      <Img
                        src="/media/images/panel/img_frame_427320451_gray_100_28x28.svg"
                        alt="circleimage"
                        className="h-[28px] w-[28px] rounded-[50%]"
                      />
                      <Text
                        size="xs"
                        as="p"
                        className="flex justify-center items-center h-[24px] px-2 py-[3px] !text-green-900 tracking-[0.72px] !font-jost border-light_green-200 border border-solid bg-light_green-100 rounded"
                      >
                        +20%
                      </Text>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex md:flex-col justify-center gap-6">
                <div className="p-5 bg-white-A700 flex-1 rounded-[10px]">
                  <div className="flex flex-col mt-1 gap-[23px]">
                    <div className="flex justify-between items-center gap-5">
                      <Heading size="xs" as="h5">
                        Users
                      </Heading>
                      <SelectBox
                        indicator={<Img src="/media/images/panel/img_arrowdown_black_900.svg" alt="arrow_down" />}
                        name="timePeriod"
                        placeholder={`This year`}
                        options={chartOptions}
                        onChange={selectedOption => setTimePeriod(selectedOption.value)}
                        className="flex w-[15%] pl-3 pr-[35px] gap-px py-3 sm:pr-5 text-black-900_9e text-sm border-gray-300_01 border border-solid bg-white-A700 rounded-md"
                      />
                    </div>
                    <div className="flex flex-col gap-3">
                      <div>
                      {Object.keys(userData).length > 0 && <LineChart data= {userData } key={JSON.stringify(userData)} options={ options } />}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[24%] md:w-full p-9 sm:p-5 bg-white-A700 rounded-[10px]">
                  <div className="flex flex-col items-center mt-1.5 gap-[42px]">
                    <div className="self-stretch">
                      <div className="h-[252px] w-[252px] relative">
                        <div className="justify-center h-[252px] w-[252px] left-0 bottom-0 right-0 top-0 m-auto absolute">
                        <CircularProgressBar totalBins={totalBins} filledBinsCount={filledBins} />
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col w-[69%] md:w-full gap-3">
                      <div className="flex justify-center items-center gap-4 p-[11px]">
                        <div className="h-[12px] w-[12px] bg-deep_orange-A100 rounded-[50%]" />
                        <Text as="p" className="self-end mt-0.5 !text-gray-800">
                          Total bins({ totalBins })
                        </Text>
                      </div>
                      <div className="flex justify-center items-center gap-4 p-[11px]">
                        <div className="h-[12px] w-[12px] bg-deep_orange-200 rounded-[50%]" />
                        <Text as="p" className="self-end mt-0.5 !text-gray-800">
                          Filled bins({ filledBins })
                        </Text>
                      </div>
                      <div className="flex justify-center items-center gap-4 p-[11px]">
                        <div className="h-[12px] w-[12px] bg-red-100 rounded-[50%]" />
                        <Text as="p" className="self-end mt-0.5 !text-gray-800">
                          UnFilled bins({ unfilledBins })
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
